import Debug from "./debug";


export default class MemoryStorage {

    private static m_map: any = {}

    static setKeyValue(key: string, data: any){
        this.m_map[key] = data
    }

    static getValue(key: string){
        return this.m_map[key]
    }

    //异步存储 微信专用 注意需要实时读取的不要用
    static setStorageNumber(key: string, data: number | Long) {
        this.m_map[key] = data
    }

    static setStorageString(key: string, data: string) {
        this.setKeyValue(key, data)
    }

    static setStorage(key: string, data: any) {
        this.setKeyValue(key, data)
    }

    static setNumber(key: string, data: number | Long) {
        this.setKeyValue(key, data)
    }

    static getNumber(key: string, defaultValue?: number) {
        try {
            var value = this.getValue(key) as Number
            return value || defaultValue
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static setJson(key: string, data: JSON) {
        try {
            this.setKeyValue(key, JSON.stringify(data));
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getJson(key: string) {
        try {
            var str = this.getString(key)
            if (str == null || str == "") {
                return null;
            }
            var data = JSON.parse(str);
            return data;
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static setString(key: string, data: String) {
        try {
            this.setKeyValue(key, data)
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getString(key: string, defaultValue?: string): string {
        try {
            var str = this.getValue(key) as string
            if (str == null || str == "") {
                if (defaultValue != null) {
                    return defaultValue;
                }
                return null;
            }
            return str;
        } catch (error) {
        }
    }

    static setItem(key: string, data: any) {
        try {
            this.setKeyValue(key, data)
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static getItem(key: string): any {
        try {
            var str = this.getValue(key)            
            return str;
        } catch (error) {
            cc.warn(key, error)
        }
    }

    static hasItem(key: string) {
        var str = this.getValue(key)
        if(str){
            return true
        }else{
            return false
        }
    }
}
